import { useLoader } from "@react-three/fiber";
import L from "leaflet";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import MiniMap from "leaflet-minimap";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Form, Row } from "reactstrap";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import logo from "../../assets/images/logo.png";
import CustomDrawer from "../../components/CustomDrawer";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import { GetSlideByIdCall } from "../../redux/api/title.api";
import "./map.css";

function ShowTile({ history }) {
  const userData = history?.location?.state?.data?.array;
  const { id, lang } = useParams();
  const mapRef = useRef(null); // Ref for storing map instance

  const content = userData?.content;

  const [info, setInfo] = useState([]);
  const [geoJson, setGeoJson] = useState([]);

  const [showLoader, setShowLoader] = useState(false);
  const [uploadProgress, setUploadPercentage] = useState(0);

  const [drawerOpen, setOpenDrawer] = useState(false);
  const [activeDeleteButton, setActiveDeleteButton] = useState(false);
  const [tileURL, setTitleURL] = useState(``);
  const [key, setKey] = useState(0);
  ////3d modles

  useEffect(() => {
    fetchSlide();
  }, []);
  /////////
  /////////
  function generateUniqueId() {
    return "id-" + Math.random().toString(36).substr(2, 16);
  }
  const fetchSlide = async () => {
    const res = await GetSlideByIdCall({
      id,
      lang,
    });
    ////here ......
    if (mapRef.current) {
      mapRef.current.remove();
      mapRef.current = null;
    }
    setGeoJson(res);

    setActiveDeleteButton(res?.Files?.[0]?.url ? true : false);
    setTitleURL(`${res?.Files?.[0]?.url}/{z}/{x}/{y}.png`);
    // window.location.reload();
  };
  useEffect(() => {
    setTimeout(() => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }

      if (!isEmpty(geoJson) && tileURL && !mapRef.current) {
        mapRef.current = L.map("map").setView([-10.505, -0.09], 2);
        const map = mapRef.current;
        L.tileLayer(tileURL, {
          attribution:
            '&copy; <a href="https://microlab.ink">Microlab</a> contributors',
        }).addTo(map);
        //////////
        

        const baseLayer = L.tileLayer(tileURL, {
          attribution: '&copy; <a href="https://microlab.ink">Microlab</a>',
          noWrap: true,
          bounds: [[-90, -180], [90, 180]],
        }).addTo(map);
        
        const miniMapLayer = L.tileLayer(tileURL, {
          noWrap: true,
          bounds: [[-90, -180], [90, 180]],
        });
        new MiniMap(miniMapLayer, {
          zoomLevelFixed: 2,
          position: "bottomleft",
          width: 120,
          height: 120,
        }).addTo(map);
        
        ////////
        ////////

        /////////
        ///////// show the saved pins

        geoJson?.pins.forEach((pin) => {
          const location = JSON.parse(pin.locations);
          const coordinates = location.data.geometry.coordinates;
          const marker = L.marker([coordinates[1], coordinates[0]]).addTo(map);

          const titleLocalization = pin.pinLocalizations?.find(
            (loc) => loc.field === "title" && loc.language === lang
          );
          const bodyLocalization = pin.pinLocalizations?.find(
            (loc) => loc.field === "body" && loc.language === lang
          );
          let title = titleLocalization?.value || "No title";
          let body = bodyLocalization?.value || "No content";
          const updatedPin = {
            ...pin,
            title,
            body,
          };

          const popupHtml = `
            <div style="max-width:250px;">
              <h4 style="margin:0;">${title}</h4>
              <p style="margin-top:6px;">${body}</p>
            </div>
          `;

          marker.bindPopup(popupHtml); // ✔ bind ONCE

          marker.on("click", () => {
            setInfo(updatedPin);
            marker.openPopup(); // ✔ only open
          });
        });
        /////////
        /////////
        // FeatureGroup is to store editable layers
        var drawnItems = new L.FeatureGroup();
        map.addLayer(drawnItems);

        const watermark = L.control({ position: "bottomright" });
        watermark.onAdd = function (map) {
          const div = L.DomUtil.create("div", "watermark");
          div.style.background = "transparent"; // Ensure background is transparent
          div.innerHTML = `<img src=${logo} alt="Microlab Watermark" style="width: 100px; height: auto;">`;
          return div;
        };
        watermark.addTo(map);
        ///////////////

        return () => {
          // Cleanup map on component unmount
          if (mapRef.current) {
            mapRef.current.remove();
            mapRef.current = null;
          }
        };
      }
    }, 1000);
  }, [tileURL]);

  const toggleDrawer = (open) => {
    setOpenDrawer(open);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="content">
        <CardHeader>
          {showLoader && (
            <CardBody>
              <Form>
                <div>
                  <div
                    style={{
                      marginBottom: 20,
                      height: "10px",
                      backgroundColor: "#ddd",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: `${uploadProgress}%`,
                        backgroundColor: "green",
                      }}
                    ></div>
                  </div>
                </div>
              </Form>
            </CardBody>
          )}
        </CardHeader>

        <Row>
          <Col md="12">
            <Card className="card-user">
              <CardBody>
                <Form>
                  <div id={"map"} style={{ width: "100%", height: "70vh" }} />
                  <CustomDrawer
                    data={info}
                    lang={lang}
                    slide_id={id}
                    fetchSlide={fetchSlide}
                    open={drawerOpen}
                    toggleDrawer={toggleDrawer}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </DashboardLayout>
  );
}

const Model = ({ fbxUrl, onLoad }) => {
  const fbx = useLoader(FBXLoader, fbxUrl, (loader) => {
    loader.manager.onLoad = onLoad;
  });

  return <primitive object={fbx} />;
};

export default ShowTile;
